import { Box, Typography } from "@mui/material";
import { EmptyStateProps } from "./EmptyState.types";

const EmptyState = ({ message, desc, icon }: EmptyStateProps) => (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight={180}
        py={4}
        color="text.secondary"
    >
        {icon}
        <Typography variant="h6" gutterBottom>
            {message}
        </Typography>
        <Typography variant="body2" color="text.secondary">
            {desc}
        </Typography>
    </Box>
);

export default EmptyState;